import { N as NcActionButton } from "./chunks/NcActionButton-CZsSFAT4.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-CIvAeDpU.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import { N as NcActionCheckbox } from "./chunks/NcActionCheckbox-BAuN4ZMC.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-CfznemNH.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import { N as NcActionRadio } from "./chunks/NcActionRadio-Bg5VuF7I.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-A918mfXE.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import { N as NcActionTextEditable } from "./chunks/NcActionTextEditable-CSP4OjpU.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-DFlcxER-.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-CLF6-i2t.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-CsG8P-1P.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-CwuKVEUN.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import { N as NcAppNavigationNew } from "./chunks/NcAppNavigationNew-DbqusDUV.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-BsnZWCLW.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-DCMN2cWp.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-n8OaxTbE.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-Cpjr8Tca.mjs";
import { N as NcAppSettingsSection } from "./chunks/NcAppSettingsSection-BNVlt4g0.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-CVcOP4bk.mjs";
import { N as NcAppSidebarHeader } from "./chunks/NcAppSidebarHeader-CBE4tNYb.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAssistantButton } from "./chunks/NcAssistantButton-lDdWOemf.mjs";
import NcAssistantContent from "./Components/NcAssistantContent.mjs";
import { N as NcAssistantIcon } from "./chunks/NcAssistantIcon-BTjYuSQ9.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-Cupl4prm.mjs";
import { u } from "./chunks/NcAvatar-Cupl4prm.mjs";
import { N as NcBlurHash } from "./chunks/NcBlurHash-DZmsBU0q.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-VJGW992x.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-DJSAcn8x.mjs";
import { N as NcButton } from "./chunks/NcButton-D3CaJu1f.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-ezquUuPz.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-w-7M5HGN.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-DpLU-oKM.mjs";
import { N as NcContent } from "./chunks/NcContent-C0_AA_wt.mjs";
import { N as NcCounterBubble } from "./chunks/NcCounterBubble-BKPpoBiy.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-CEL-DhKX.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-DeQtScn8.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-enXYuwj8.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-BM_wTqUn.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-Cr0wVMne.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-BV_iVlIv.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import { N as NcHeaderButton } from "./chunks/NcHeaderButton-TJML067P.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-D5ddiKnF.mjs";
import { N as NcHighlight } from "./chunks/index-JArK0Dbx.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-BCVwmZN2.mjs";
import { N as NcInputField } from "./chunks/NcInputField-1ujONIvp.mjs";
import { N as NcListItem } from "./chunks/NcListItem-DNMfT12A.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-PNp6Wael.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-D2iDTTpp.mjs";
import { N as NcPopover } from "./chunks/NcPopover-nzbq2IjT.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-BwnuvxiZ.mjs";
import { N as NcRadioGroup } from "./chunks/NcRadioGroup-sZaH_3Y0.mjs";
import { N as NcRadioGroupButton } from "./chunks/NcRadioGroupButton-B6m10k9G.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-Q6jZk-Pm.mjs";
import { N as NcMentionBubble } from "./chunks/index-BsEMR4S4.mjs";
import { r } from "./chunks/index-BsEMR4S4.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-8_poOeSx.mjs";
import "@nextcloud/auth";
import "@nextcloud/axios";
import "@nextcloud/router";
import "@nextcloud/sharing/public";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a, g, b, c, s, d } from "./chunks/referencePickerModal-DpJUQ5fq.mjs";
import { N, h, c as c2, i, e, r as r2, f, a as a2 } from "./chunks/customPickerElements-BPROmh4T.mjs";
import "unist-builder";
import "unist-util-visit";
import "./chunks/logger-D3RVzcfQ.mjs";
import { N as NcRichText } from "./chunks/NcRichText-Dnx5x9WS.mjs";
import { N as NcSelect } from "./chunks/NcSelect-TjZw7TJ_.mjs";
import { N as NcTextField } from "./chunks/NcTextField-BE9R1pLt.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-U7AIamCl.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-CytnLDOw.mjs";
import { N as NcSelectUsers } from "./chunks/NcSelectUsers-Bm0877Tm.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-DPAtsY2T.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-CX5q924g.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-CR4XLrgs.mjs";
import { N as NcTextArea } from "./chunks/NcTextArea-If_ygOSv.mjs";
import { N as NcThemeProvider } from "./chunks/NcThemeProvider-E_S5rhIQ.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-D4y736xC.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-8Mts76ii.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-BWxo_etm.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { useFormatDateTime, useFormatRelativeTime, useFormatTime } from "./Composables/useFormatDateTime.mjs";
import { useHotKey } from "./Composables/useHotKey.mjs";
import { useIsDarkTheme, useIsDarkThemeElement } from "./Composables/useIsDarkTheme.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { getEnabledContactsMenuActions, registerContactsMenuAction } from "./Functions/contactsMenu.mjs";
import { spawnDialog } from "./Functions/dialog.mjs";
import { E, a as a3, e as e2, g as g2, s as s2 } from "./chunks/emoji-V6ytyzoR.mjs";
import { checkIfDarkTheme, isDarkTheme } from "./Functions/isDarkTheme.mjs";
import { preloadImage } from "./Functions/preloadImage.mjs";
import { usernameToColor } from "./Functions/usernameToColor.mjs";
import directive from "./Directives/Focus.mjs";
import directive$1 from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a as anyLinkProviderId,
  checkIfDarkTheme,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e2 as emojiSearch,
  g2 as getCurrentSkinTone,
  getEnabledContactsMenuActions,
  g as getLinkWithPicker,
  b as getProvider,
  c as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  c2 as isCustomPickerElementRegistered,
  isDarkTheme,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  preloadImage,
  registerContactsMenuAction,
  e as registerCustomPickerElement,
  r2 as registerWidget,
  f as renderCustomPickerElement,
  a2 as renderWidget,
  r as richEditor,
  s as searchProvider,
  s2 as setCurrentSkinTone,
  d as sortProviders,
  spawnDialog,
  useFormatDateTime,
  useFormatRelativeTime,
  useFormatTime,
  useHotKey,
  useIsDarkTheme,
  useIsDarkThemeElement,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  usernameToColor
};
//# sourceMappingURL=index.mjs.map
